import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import { InputControl } from "../../../shared";
import SimpleReactValidator from "simple-react-validator";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";
import moment from "moment/moment";

export const RegenerateDialog = (props) => {
  const {
    onSubmit,
    templates,
    onChangeEffectiveDate,
    setTemplates,
    handleClose,
    isDisabled,
  } = props;

  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const { alert_radio, effective_date } = templates;
  const onSubmitData = () => {
    if (validator.current.allValid()) {
      onSubmit("update");
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };
  const today = new Date().toISOString().split("T")[0];
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowDate = tomorrow.toISOString().split("T")[0];

  const handleRadioChange = (event) => {
    const value = event.target.value;
    let selectedDate;
    if (value === "1") {
      selectedDate = today;
    } else if (value === "2") {
      selectedDate = tomorrowDate;
    }

    setTemplates((draft) => {
      draft.alert_radio = value;
      draft.effective_date = selectedDate;
    });
  };
  const todays = new Date();
  const maxDate = new Date(today);
  maxDate?.setDate(todays?.getDate() + 6);

  return (
    <React.Fragment>
      <Stack sx={{ padding: "16px 20px 0px 20px" }}>
        <FormControl>
          <RadioGroup
            sx={{ gap: "8px" }}
            value={alert_radio}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              control={<Radio />}
              label="Update From Today"
              value="1"
            />
            <FormControlLabel
              control={<Radio />}
              label="Update From Tomorrow"
              value="2"
            />
            <FormControlLabel
              control={<Radio />}
              label="Update From :"
              value="3"
            />
          </RadioGroup>
        </FormControl>

        {alert_radio === "3" && (
          <>
            <InputControl
              sx={{ width: "250px", mt: "8px" }}
              size="small"
              name="effective_date"
              value={effective_date ? new Date(effective_date) : null}
              disablePast
              minDate={todays}
              maxDate={maxDate}
              type="datePicker"
              inputFormat="dd/MM/yyyy"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              onChange={(dateValue) => onChangeEffectiveDate(dateValue)}
            />

            <FormHelperText>
              {templates?.data?.end_date &&
                `Ending on ${moment(templates?.data?.end_date).format(
                  "DD/MM/YYYY"
                )}`}
            </FormHelperText>
          </>
        )}

        <FormHelperText sx={{ color: "error.main" }}>
          {validator.current.message(
            "Effective Date",
            templates.effective_date,
            "required"
          )}
        </FormHelperText>
      </Stack>
      <CustomDialogFooter
        onSubmit={onSubmitData}
        loading={isDisabled}
        disabled={isDisabled}
        handleClose={handleClose}
      />
    </React.Fragment>
  );
};
